import React from 'react'
import PriorityStorePage from './PriorityStorePage'
import { canViewStoreName as checkStoreName } from '../../../services/StorageServices'

const PriorityStorePageContainer = () => {
    if (!checkStoreName()) {
        return <div className="text-center mt-5"><h4>You do not have permission to access this page.</h4></div>
    }

    return (
        <div className='PriorityStorePageContainer'>
            <PriorityStorePage/>
        </div>
    )
}

export default PriorityStorePageContainer